<template>
  <v-menu
    v-model="menuOpen"
    :close-on-content-click="false"
    max-width="290">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="displayValue"
        :clearable="!disabled"
        :label="label || 'Date'"
        readonly
        v-bind="attrs"
        v-on="on"
        :disabled="disabled"
        @click:clear="clear();"></v-text-field>
    </template>
    <v-date-picker
      v-model="dateValue"
      @change="menuOpen = false;"></v-date-picker>
  </v-menu>
</template>

<script>

import moment from 'moment';

export default {
  'name' : 'MenuDatePicker',
  'props' : [
    'value',
    'label',
    'disabled'
  ],
  'data' : function() {
    return {
      'menuOpen' : false,
      'displayValue' : '',
      'dateValue' : null
    };
  },
  'created' : function() {
  },
  'watch' : {
    'dateValue' : {
      'handler' : function() {
        var emission = null;
        if(this.dateValue == null) {
          this.displayValue = '';
        }
        else {
          emission = moment(this.dateValue, 'YYYY-MM-DD');
          this.displayValue = emission.format('YYYY-MM-DD');
        }
        this.$emit('input', emission);
      }
    },
    'disabled' : function() {
      if(this.disabled) {
        this.menuOpen = false;
      }
    },
    'value' : {
      'handler' : function() {
        var m = moment(this.value, 'YYYY-MM-DD');
        if(m.isValid()) {
          this.dateValue = m.format('YYYY-MM-DD');
        }
        else {
          this.dateValue = null;
        }
      }
    }
  },
  'methods' : {
    'clear' : function() {
      this.dateValue = null;
    }
  }
};

</script>